import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { useMobile } from '../../hooks/useMobile';

import { ROUTE_PATH } from '../../route/utils';

// Hidden for now, see the Account NavigationSegment below: import { ReactComponent as AccountIcon } from '../../icons/account.svg';
import { ReactComponent as AdminIcon } from '../../icons/admin.svg';
import { ReactComponent as CartIcon } from '../../icons/cart.svg';
import { ReactComponent as MenuIcon } from '../../icons/food-menu.svg';
import { ReactComponent as LogoIcon } from '../../icons/logo.svg';
import { ReactComponent as MoreHorizontalIcon } from '../../icons/menu.svg';
import { ReactComponent as MoreIcon } from '../../icons/more.svg';
import { ReactComponent as OrdersIcon } from '../../icons/orders.svg';

import NavigationPopup from './navigation-popup/NavigationPopup';
import NavigationSegment from './navigation-segment/NavigationSegment';
import './navigation.scss';

import Popup from '../common/popup/Popup';
import Header from '../header/Header';
import { AdaptiveModal } from '../modal/AdaptiveModal';
import { CreateMealModal } from '../modal/create-meal/CreateMealModal';
import { MealChoiceModal } from '../modal/meal-choice/MealChoiceModal';
import { OrderModal } from '../modal/order/OrderModal';
import { OrderStatusModal } from '../modal/order/status/OrderStatusModal';
import CartSidebar from '../page/cart/CartSidebar';
import { MealPlannerModal } from '../page/meal-planner/MealPlannerModal';

const Navigation = ({ children }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const triggerRef = useRef(null);
  const { signOut, isAdmin, user } = useAuth();
  const isLoggedIn = user && !user.isAnonymous;
  const isMobile = useMobile();
  const { cartOpen, setCartOpen, cartCount } = useCart();

  useEffect(() => {
    if (!isMobile) {
      setCartOpen(false);
    }
    //eslint-disable-next-line
  }, [isMobile]);

  const handleOpenCart = () => {
    if (isMobile) {
      setCartOpen(false);
      return navigate(ROUTE_PATH.CART, { replace: true });
    } else {
      setCartOpen(!cartOpen);
    }
  };

  const handleButtonClick = () => {
    setIsVisible(!isVisible);
  };

  const handlePopperClose = () => {
    setIsVisible(false);
  };

  return (
    <>
      <nav className="navigation">
        <LogoIcon />
        <NavigationSegment label="Menu" icon={MenuIcon} route={ROUTE_PATH.MENU} />
        {isMobile && (
          <NavigationSegment
            label="Cart"
            icon={CartIcon}
            route={ROUTE_PATH.CART}
            onClickOverride={handleOpenCart}
            count={cartCount}
            showNotification={cartCount > 0}
          />
        )}
        {isLoggedIn && (
          <NavigationSegment label="Orders" icon={OrdersIcon} route={ROUTE_PATH.ORDERS} />
        )}
        {/* Hidden for now: {isLoggedIn && <NavigationSegment label="Account" icon={AccountIcon} route={ROUTE_PATH.ACCOUNT} />} */}
        {!isMobile && isAdmin && (
          <NavigationSegment label="Admin Panel" icon={AdminIcon} route={ROUTE_PATH.ADMIN_PANEL} />
        )}
        <div>
          {!isMobile && (
            <NavigationSegment
              label="Cart"
              icon={CartIcon}
              route={ROUTE_PATH.CART}
              onClickOverride={handleOpenCart}
              count={cartCount}
              showNotification={cartCount > 0}
            />
          )}
          <div ref={triggerRef}>
            <NavigationSegment
              label="Menu"
              icon={isMobile ? MoreHorizontalIcon : MoreIcon}
              onClickOverride={handleButtonClick}
              tooltip={false}
            />
            {!isMobile && (
              <Popup
                isVisible={isVisible}
                triggerRef={triggerRef}
                onClose={handlePopperClose}
                offset={{ top: 0, left: 47 }}
                width={300}
              >
                <NavigationPopup onSignOutClick={() => signOut()} className="" />
              </Popup>
            )}
            {isMobile && (
              <AdaptiveModal
                open={isVisible}
                onOpen={setIsVisible}
                background="background-secondary"
                mobileAutoHeight
              >
                <NavigationPopup onSignOutClick={() => signOut()} />
              </AdaptiveModal>
            )}
          </div>
        </div>
      </nav>
      <section className="navigation__content">
        <Header />
        <div>{children}</div>
      </section>
      <section className="navigation__sidebar">{cartOpen && <CartSidebar />}</section>
      <MealChoiceModal />
      <CreateMealModal />
      <MealPlannerModal />
      <OrderModal />
      <OrderStatusModal />
    </>
  );
};

export default Navigation;
